module.exports = __webpack_public_path__ + "img/peanut.f7c46f1a.svg";